module.exports = __webpack_public_path__ + "static/profile-pic-0b6178d8373978bea8aff498baaca8ef.jpg";